import axios from "axios";

const Url = process.env.REACT_APP_URl;
const Url2 = process.env.REACT_APP_URl2;

export const UpgradeCredit = async () => {
    const apiUrl = Url + "/api/upgradecredit";
    const response = await axios.post(apiUrl, "", {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const GenerateApiKeyServ = async () => {
    const apiUrl = Url + "/generate-apikey";
    const response = await axios.post(apiUrl, "", {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const GetApiKey = async () => {
    const apiUrl = Url + "/get-apikey";
    const response = await axios.get(apiUrl, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const GetImageOrder = async () => {
    const apiUrl = Url + "/settings/imageorder";
    const response = await axios.get(apiUrl, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const SaveSetBestImageFront = async (imageorder: string[]) => {
    const apiUrl = Url + "/settings/imageorder";
    const response = await axios.put(apiUrl, { imageorder }, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const ServiceHasAcsess = async () => {
    const apiUrl = Url + "/hasAcsess";
    const response = await axios.get(apiUrl, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const GetAgentLogs = (platforms: any, grouped: any, page: any, id: any) => {
    const apiUrl = Url + `/userLogSummary/${id}/${platforms}/${grouped}`;
    return axios.post(apiUrl, { page: page, limit: 10 }, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    }).then((response) => {
        return response.data;
    })
}

export const GetCreditScoreAgent = (id: any) => {
    const apiUrl = Url + `/credit_score/${id}`;
    return axios.get(apiUrl, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    }).then((response) => {
        return response.data;
    })
}
export const AgentConsumption = (id: any) => {
    const apiUrl = Url + `/user-consumption/${id}`;
    return axios.get(apiUrl, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    }).then((response) => {
        return response.data;
    })
}

export const GetUserLogs = (platforms: any, grouped: any, page: any) => {
    const apiUrl = Url + `/userLogSummary/${platforms}/${grouped}`;
    return axios.post(apiUrl, { page: page, limit: 10 }, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    }).then((response) => {
        return response.data;
    })
}


export const GetCreditScore = () => {
    const apiUrl = Url + "/credit_score";
    return axios.get(apiUrl, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    }).then((response) => {
        return response.data;
    })
}
export const UserConsumption = () => {
    const apiUrl = Url + "/user-consumption";
    return axios.get(apiUrl, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    }).then((response) => {
        return response.data;
    })
}

export const GetStats = () => {
    const apiUrl = Url + `/stats`;
    return axios.get(apiUrl, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    }).then((response) => {
        return response.data;
    })
}

export const GetPhotoUsage = (period: string) => {
    const apiUrl = Url + `/stats/photo-usage-by-type`;
    return axios.post(apiUrl, { period: period }, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    }).then((response) => {
        return response.data;
    })
}

export const GetStatsUsages = () => {
    const apiUrl = Url + `/stats/usage`;
    return axios.get(apiUrl, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    }).then((response) => {
        return response.data;
    })
}

export const UpgradeCreditServ = async () => {
    const response = await axios.post(Url + "/api/upgradecredit", {}, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const getInvoice = async () => {
    const response = await axios.get(Url2 + "/api/v1/subscriptions/user/invoices", {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken"),
        }
    })
    return response.data;
}


